import script from "./DeviceManagement.vue?vue&type=script&lang=ts&setup=true"
export * from "./DeviceManagement.vue?vue&type=script&lang=ts&setup=true"

import "./DeviceManagement.vue?vue&type=style&index=0&id=07595c1e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07595c1e"]])

export default __exports__